exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1jLw {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    margin: auto;\n    max-width: 500px;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    padding: 15px;\n}\n\n._3ynP {\n    padding-bottom: 20px;\n    padding-top: 10px;\n    text-align: center;\n}\n\n._16wO {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 21px;\n    margin-top: 5px;\n    margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_1jLw",
	"header": "_3ynP",
	"heading": "_16wO"
};